/*
 * No SCSS was attached to this component. It used classes defined in BuilderOptionsBlock.scss
 * (injected globally via BuilderOptionsBlock's import). The shared classes are:
 *   .bob-options-section → flex flex-col gap-[10px]
 *   .bob-options-list    → flex flex-col gap-[8px]
 * Both are now owned locally — no cross-file stylesheet dependency.
 *
 * Arbitrary values used: gap-[10px] (no exact DS token at 10px), gap-[8px]
 */
import { Input, Label } from '@quickmd-llc/design-system'
import { memo } from 'react'

type OptionItem = {
  optionId: string
}

type Props = {
  options: OptionItem[]
}

const BuilderOptionsBlockHeightWeight = memo(({ options }: Props) => {
  const labels = ['How tall are you?', 'What is your current weight? (lbs)']

  return (
    <div className='flex flex-col gap-[10px]'>
      <Label size='md'>Options</Label>
      <div className='flex flex-col gap-[8px]'>
        {options.map((option, index) => (
          <Input key={option.optionId} value={labels[index] ?? ''} disabled />
        ))}
      </div>
    </div>
  )
})

export { BuilderOptionsBlockHeightWeight }
